import { render, staticRenderFns } from "./Minimumtax.vue?vue&type=template&id=34b5ac42"
import script from "./Minimumtax.vue?vue&type=script&lang=js"
export * from "./Minimumtax.vue?vue&type=script&lang=js"
import style0 from "./Minimumtax.vue?vue&type=style&index=0&id=34b5ac42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports